import con from '../../../../connection';
var path = '/categories';
var categories = function (url) { return function () { return ({
    get: function (param) { return con.get(url + path, param || {}); },
}); }; };
export default categories;
